'use client';

import { c as _c } from "react/compiler-runtime";
import { Suspense } from 'react';
import { LoadingPageTemplate } from '@/components/client';
import { PolicyFitFilterForm } from '@/components/client/Form/PolicyFitFilterForm';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useGetCustomPolicyFilterDataQuery } from '@/hooks/useGetCustomPolicyFilterDataQuery';
import { GTM_EVENT_TYPE, trackGtmEvent } from '@/utils/analytics/gtm';
import { usePostCustomPolicyFilterDataMutation } from '../_hooks/usePostCustomPolicyFilterDataMutation';
export const CustomPolicyFilter = () => {
  const $ = _c(10);
  const {
    data,
    isLoading
  } = useGetCustomPolicyFilterDataQuery();
  const router = useCustomRouter();
  let t0;
  if ($[0] !== router) {
    t0 = {
      onSuccess: () => {
        router.back();
      }
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    mutate: saveBasicFilter,
    isPending
  } = usePostCustomPolicyFilterDataMutation(t0);
  let t1;
  if ($[2] !== data?.familyCount || $[3] !== data?.familyIncome || $[4] !== data?.filterValues || $[5] !== data?.unemploymentDate || $[6] !== isLoading || $[7] !== isPending || $[8] !== saveBasicFilter) {
    t1 = isLoading ? <LoadingPageTemplate /> : <Suspense fallback={<LoadingPageTemplate />}><PolicyFitFilterForm genderFilter={true} resetButton={true} initialValues={{
        filterValues: data?.filterValues ?? [],
        familyCount: data?.familyCount ?? 0,
        familyIncome: data?.familyIncome ?? 0,
        unemploymentDate: data?.unemploymentDate
      }} isSubmitting={isPending} submitButtonLabel={"\uC218\uC815 \uC644\uB8CC"} onSubmit={data_0 => {
        const recommendCategory = data_0.filterValues.map(_temp).join(", ");
        trackGtmEvent(GTM_EVENT_TYPE.COMPLETE_RECOMMEND, {
          recommend_category: recommendCategory
        });
        saveBasicFilter({
          body: {
            familyCnt: data_0.familyCount,
            codeList: data_0.filterValues.map(_temp2),
            salary: data_0.familyIncome,
            unemploymentDate: data_0.unemploymentDate ?? undefined
          }
        });
      }} /></Suspense>;
    $[2] = data?.familyCount;
    $[3] = data?.familyIncome;
    $[4] = data?.filterValues;
    $[5] = data?.unemploymentDate;
    $[6] = isLoading;
    $[7] = isPending;
    $[8] = saveBasicFilter;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
function _temp(item) {
  return item.value;
}
function _temp2(t0) {
  const {
    level: t1,
    code: t2
  } = t0;
  const level = t1 === undefined ? 0 : t1;
  const code = t2 === undefined ? "" : t2;
  return {
    code,
    level
  };
}